import React, { useEffect } from 'react';
import { useLanguage } from '../../../hooks/useLanguage';
import { aside as frAside } from '../../../locales/fr/aside';
import { aside as arAside } from '../../../locales/ar/aside';
import { aside as esAside } from '../../../locales/es/aside';
import useMyAppStore from '../../../stores/myAppStore';

const translations = {
  fr: frAside,
  ar: arAside,
  es: esAside
};

const Activites = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const { setPageTitle } = useMyAppStore();

  useEffect(() => {
    setPageTitle(t.routes.activities);
  }, [lang, t.routes.activities, setPageTitle]);

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        {lang === 'ar' ? 'النشاطات' : 'Activités'}
      </h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {lang === 'ar' ? 'الاسم' : 'Nom'}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {lang === 'ar' ? 'النوع' : 'Type'}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {lang === 'ar' ? 'التاريخ' : 'Date'}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" colSpan="3">
                {lang === 'ar' ? 'لا توجد نشاطات' : 'Aucune activité'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Activites; 